export const enMainLocale = {
  app_name: 'Apollo Reading',
  app_name_possessive: "Apollo Reading's",
};
